import React from "react";

const NerveSparks = () => {
  return (
    <div>
      <div>
        {/* Experience list */}
        <div className=" ">
          <div className=" mt-10">
            <h3 className=" text-3xl font-bold text-gray-400">
              {" "}
              Job ( Sharajman Technologies )
            </h3>
            <div className=" flex flex-col gap-4 mt-4 ml-4">
              <div>
                <span className="font-bold text-lg text-gray-400">
                  Role:
                </span>{" "}
Full Stack Developer
              </div>
              <div className=" ">
                <span className="font-bold text-lg text-gray-400">
                  Location :
                </span>{" "}
                Delhi, India
              </div>
              <div>
                <span className="font-bold text-lg text-gray-400">
                  Duration :
                </span>{" "}
               Sep 2024 - Present
              </div>
              <div>
                <span className="font-bold text-lg text-gray-400">
                  Tech Stack :
                </span>{" "}
                <span class="  text-xs font-medium me-2 px-2.5 py-0.5 rounded bg-gray-900 text-red-400 border border-red-500">
                  Angular_JS
                </span>{" "}
                <span class="  text-xs font-medium me-2 px-2.5 py-0.5 rounded bg-gray-900 text-purple-400 border border-purple-400">
                  BootStrap
                </span>{" "}
                <span class="  text-xs font-medium me-2 px-2.5 py-0.5 rounded bg-gray-900 text-blue-400 border border-blue-400">
                  TypeScript
                </span>{" "}
                <span class="  text-xs font-medium me-2 px-2.5 py-0.5 rounded bg-gray-900 text-cyan-400 border border-cyan-400">
                  Python
                </span>{" "}
                <span class="  text-xs font-medium me-2 px-2.5 py-0.5 rounded bg-gray-900 text-green-300 border border-green-300">
                  FastAPI
                </span>{" "}
                <span class="  text-xs font-medium me-2 px-2.5 py-0.5 rounded bg-gray-900 text-pink-400 border border-pink-400">
                  SQL
                </span>{" "}

              </div>
              {/* <div>
                <h4 className=" font-bold text-lg">
                  Responsibilities and Achievements
                </h4>
                <p>
                  <ul className=" list-disc p-5 pt-2">
                    <li>
                      Led the design and implementation of an AI chatbot using
                      Next.js, Tailwind CSS, and Express.js..{" "}
                    </li>
                    <li>
                      Integrated OpenAI API, Langfuse Analytics, and Vectara
                      GenAI to enhance chatbot capabilities.{" "}
                    </li>
                    <li>
                      Implemented a secure access verification process for user
                      queries, ensuring data integrity.{" "}
                    </li>
                    <li>
                      Managed communication with OpenAI API and Langfuse
                      Analytics to enhance chatbot responses. Streamlined data
                      flow to the user end, providing a responsive chatbot
                      experience
                    </li>
                  </ul>
                </p>
              </div> */}
            </div>
          </div>
        </div>
      </div>
      <div>
        {/* Experience list */}
        <div className=" text-gray-500">
          <div className="  mt-10">
            <h3 className=" text-2xl md:text-3xl text-gray-400 font-bold">
              {" "}
              Job ( NerveSparks )
            </h3>
            <div className=" flex flex-col gap-4 mt-4 ml-4">
              <div>
                <span className="font-bold text-lg text-gray-400">Role:</span>{" "}
                Full Stack Developer
              </div>
              <div className=" ">
                <span className="font-bold text-lg text-gray-400">
                  Location :
                </span>{" "}
                Gurugram, Haryana, India
              </div>
              <div>
                <span className="font-bold text-lg text-gray-400">
                  Duration :
                </span>{" "}
                4 month
              </div>
              <div>
                <span className="font-bold text-lg text-gray-400">
                  Tech Stack :
                </span>{" "}
                <span class="  text-xs font-medium me-2 px-2.5 py-0.5 rounded bg-gray-900 text-orange-400 border border-orange-400">
                  svelte
                </span>{" "}
                <span class="  text-xs font-medium me-2 px-2.5 py-0.5 rounded bg-gray-900 text-green-400 border border-green-400">
                  Ligntgraph JS
                </span>{" "}
                <span class="  text-xs font-medium me-2 px-2.5 py-0.5 rounded bg-gray-900 text-yellow-400 border border-yellow-400">
                  JavaScript
                </span>{" "}
                <span class="  text-xs font-medium me-2 px-2.5 py-0.5 rounded bg-gray-900 text-gray-400 border border-gray-500">
                  Selenium
                </span>{" "}
                <span class="  text-xs font-medium me-2 px-2.5 py-0.5 rounded bg-gray-900 text-purple-400 border border-purple-400">
                  Tailwind_css
                </span>{" "}
                <span class="  text-xs font-medium me-2 px-2.5 py-0.5 rounded bg-gray-900 text-red-400 border border-red-400">
                  Git
                </span>{" "}
                <span class="  text-xs font-medium me-2 px-2.5 py-0.5 rounded bg-gray-900 text-gray-300 border border-gray-300">
                  Express_js
                </span>{" "}
                <span class="  text-xs font-medium me-2 px-2.5 py-0.5 rounded bg-gray-900 text-blue-400 border border-blue-400">
                  Python
                </span>{" "}
              </div>
              <div>
                <h4 className=" font-bold text-lg text-gray-400">
                  Responsibilities and Achievements
                </h4>
                <p>
                  <ul className=" list-disc p-5 pt-2">
                    <li>
                      Update the UI of the website using SvelteKit, Tailwind
                      CSS, and GSAP.{" "}
                    </li>
                    <li>
                      Integrated PyTorch and Hugging Face in the node-based
                      system using Lightgraph.js.{" "}
                    </li>
                    <li>
                      Implemented connection and disconnection logic between
                      nodes, providing a seamless user experience
                    </li>
                  </ul>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NerveSparks;
